import { TransactionNotification } from "common/interfaces";
import { TransactionStatusEnum } from "common/enums/TransactionStatus.enum";
import { CompanyInfoStatusEnum } from "common/enums/CompanyInfoStatus.enum";
import { QuestNotification } from "reducers/questApi";

/**
 * Notice line for an auto-claimed hidden quest, shown in the dashboard
 * "クエスト達成のお知らせ" block. When the quest grants a badge, its name is shown
 * inline next to the XP reward.
 */
export const questNotificationText = (data: QuestNotification): string => {
  const reward = data.badge_name
    ? `${data.reward_xp}XPと「${data.badge_name}」バッジ`
    : `${data.reward_xp}XP`;
  return `隠しクエスト「${data.title}」を達成しました。${reward}を獲得しました。ご確認ください。`;
};

export const transactionNotificationText = (
  data: TransactionNotification,
): string => {
  switch (data.type) {
    case "conversation":
      return `出品商品「${data.product.product_name}」の取引メッセージが届いています。`;
    case "transaction":
      if (data.status === TransactionStatusEnum.NEGOTIATE) {
        return `商品「${data.product.product_name}」の交渉を希望している人がいます`;
      }
      if (data.status === TransactionStatusEnum.REQUEST) {
        return `出品商品「${data.product.product_name}」この商品は購入申請中です。`;
      }
      if (data.status === TransactionStatusEnum.ACCEPT) {
        return `出品商品「${data.product.product_name}」この商品は発送待ちです。`;
      }
      if (data.status === TransactionStatusEnum.REJECT) {
        return `商品「${data.product.product_name}」の取引を出品者が拒否しました`;
      }
      if (data.status === TransactionStatusEnum.DELIVERED_TO_SHIP) {
        return `出品商品「${data.product.product_name}」この商品は受け取り待ちです。`;
      }
      if (data.status === TransactionStatusEnum.COMPLETED) {
        return `出品商品「${data.product.product_name}」取引が完了しました。`;
      }
      if (data.status === TransactionStatusEnum.INVOICE_ISSUED) {
        return `出品商品「${data.product.product_name}」請求書が発行されました。`;
      }
      if (data.status === TransactionStatusEnum.SELLER_REQUEST_CANCEL) {
        return `出品商品「${data.product.product_name}」売り手企業からキャンセル申請が届きました。`;
      }
      if (data.status === TransactionStatusEnum.SELLER_ACCEPT_CANCEL) {
        return `出品商品「${data.product.product_name}」取引がキャンセルされました。`;
      }
      if (data.status === TransactionStatusEnum.RECEIVED) {
        return `出品商品「${data.product.product_name}」この商品は受け取りが完了しました。`;
      }
      if (data.status === TransactionStatusEnum.BUYER_REQUEST_CANCEL) {
        return `出品商品「${data.product.product_name}」に買い手企業からキャンセル申請が届きました。`;
      }
      if (data.status === TransactionStatusEnum.BUYER_ACCEPT_CANCEL) {
        return `出品商品「${data.product.product_name}」に取引がキャンセルされました。`;
      }
  }
  return ``;
};

export const companyInfoStatusMap: Record<any, string> = {
  [CompanyInfoStatusEnum.PENDING_REVIEW]: "審査待ち",
  [CompanyInfoStatusEnum.APPROVED]: "承認済み",
  [CompanyInfoStatusEnum.REJECTED]: "否認済",
  [CompanyInfoStatusEnum.FROZEN]: "凍結中",
};
